/** Locales mirror the backend `preferredLocale` enum: ar | en | ckb. */
export const LOCALES = ['en', 'ar', 'ckb'] as const;
export type Locale = (typeof LOCALES)[number];

/** What a first visit gets, before anyone has chosen. Arabic, RTL. */
export const DEFAULT_LOCALE: Locale = 'ar';
/** Where the user's own choice is kept; `index.html` reads it before first paint. */
export const LOCALE_STORAGE_KEY = 'uruanna.locale';

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  ar: 'العربية',
  ckb: 'کوردی',
};

const RTL: ReadonlySet<string> = new Set(['ar', 'ckb']);

export function isRtlLocale(locale: string): boolean {
  return RTL.has(locale.split('-')[0]);
}
